import { S3Client, ListObjectsV2Command } from "@aws-sdk/client-s3";

const s3Client = new S3Client({
  region: "sa-east-1",
  credentials: {
    accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
    secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
  },
});

const BUCKET_NAME = "repoeticpro";
const FOLDER_PREFIX = "momentos/";

export const listGalleryImages = async () => {
  try {
    console.log("🔍 Listando imágenes desde S3:", `${BUCKET_NAME}/${FOLDER_PREFIX}`);
    
    const command = new ListObjectsV2Command({
      Bucket: BUCKET_NAME,
      Prefix: FOLDER_PREFIX,
      MaxKeys: 100,
    });

    const response = await s3Client.send(command);
    
    if (!response.Contents || response.Contents.length === 0) {
      console.log("📂 Carpeta momentos está vacía");
      return [];
    }

    const imageExtensions = [".jpg", ".jpeg", ".png", ".gif", ".webp", ".avif"];
    const images = response.Contents
      .filter(object => {
        const key = object.Key.toLowerCase();
        return key !== FOLDER_PREFIX && imageExtensions.some(ext => key.endsWith(ext));
      })
      .map(object => ({
        key: object.Key,
        filename: object.Key.replace(FOLDER_PREFIX, ""),
        size: object.Size,
        url: `https://${BUCKET_NAME}.s3.sa-east-1.amazonaws.com/${object.Key}`,
        lastModified: object.LastModified
      }));

    console.log(`✅ ${images.length} imágenes encontradas en S3`);
    return images;
    
  } catch (error) {
    console.error("❌ Error al listar imágenes S3:", error.message);
    throw error;
  }
};
